class ChannelContentObj {
  constructor() {
    this.interposer = new ChannelContentItem();
    this.package = new ChannelContentItem();
  }
}
class ChannelContentItem {
  constructor({ Signals, Components, PowerNets, Ports_generate_setup_list, Port_setups, ReferenceNets }) {
    this.Signals = Signals || []; // [Signal]
    this.Components = Components || []; // [RLCCONComponent,ICComponent]
    this.PowerNets = PowerNets || []; // [SourceNets]
    this.Ports_generate_setup_list = Ports_generate_setup_list || [];
    this.ReferenceNets = ReferenceNets || [];
    this.Port_setups = Port_setups || [];
  }
}

const CONTENT_KEY_INTERPOSER = "interposer",
  CONTENT_KEY_PACKAGE = "package";

export {
  ChannelContentObj,
  ChannelContentItem,
  CONTENT_KEY_INTERPOSER,
  CONTENT_KEY_PACKAGE
}